// src/components/notificationTypes.js

// 🎨 Иконки можно потом заменить на SVG
// пока используем emoji — как в Avito MVP

export const NOTIFICATION_META = {
  // 👤 Подписки на продавца
  new_ad: {
    title: "Δημοσίευσε νέα αγγελία:",
    icon: "🆕",
    color: "#2563eb", // blue
  },  

  favorite_ad_completed: {
    title: "Μια αποθηκευμένη αγγελία ολοκληρώθηκε:",
    icon: "📦",
    color: "#16a34a",
  },
 

  favorite_ad_price_changed: {
    title: "Μειώθηκε η τιμή σε αποθηκευμένη αγγελία:",
    icon: "📉",
    color: "#16a34a",
  },

  // 💬 чат (на будущее)
  new_message: {
    title: "σας έστειλε μήνυμα",
    icon: "💬",
    color: "#7c3aed", // purple
  },
};

// безопасный getter
export const getNotificationMeta = (type) =>
  NOTIFICATION_META[type] || {
    title: "έχει νέα ενημέρωση",
    icon: "🔔",
    color: "#2563eb",
  };
